

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, checkAuth = true }) => {
    const accessToken = useSelector((state) => state?.common?.user_token?.accessToken);
    // Redirect to login page if the user is not authenticated
    if (checkAuth && !accessToken) {
        return <Navigate to={'/'} />;
    }

    // If user is authenticated but trying to access a non-existent route, show 404
    if (!checkAuth && accessToken) {
        return children;
    }

    // Redirect to login if trying to access a non-existent route and not logged in
    if (!checkAuth && !accessToken) {
        return <Navigate to={'/'} />;
    }

    return children;
};

export default PrivateRoute;